module.exports = __webpack_public_path__ + "static/media/HAM.3e3cb05b.png";